import {useNavigate} from 'react-router-dom';
import {RootState} from '../../Config/Store';
import {useAppDispatch, useAppSelector} from '../../Config/Hooks';
import {SystemRoutes} from '../../Utils/RouteUtils';
import {setEquipment, setSkid} from '../../Modules/Dashboard/DashboardReducer';
import {useEffect, useState} from 'react';
import {DashboardNavigationMenu} from "../Components/Layout/menu/types/DashboardNavigationMenu";


export const useEquipmentNavigation = (): (equipmentId: number) => { isSuccess: boolean } => {
    const [equipmentId, setEquipmentId] = useState<number | null>(null);
    const [equipmentWithoutSkid, setEquipmentWithoutSkid] = useState<boolean | null>(null);
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { selectedEquipment } = useAppSelector((state: RootState) => state.dashboard);
    const { entities } = useAppSelector((state: RootState) => state.dashboardNavigationMenu);

    useEffect(() => {
        if (equipmentId) {
            if(equipmentWithoutSkid){
                navigate(SystemRoutes.DASHBOARD_POWER_PLANT_EQUIPMENTS_DETAILS);
            } else {
                navigate(SystemRoutes.DASHBOARD_POWER_PLANT_SKID_EQUIPMENTS_DETAILS);
            }
            setEquipmentId(null)
            setEquipmentWithoutSkid(null);
        }
    }, [selectedEquipment, equipmentId]);

    function navigateToEquipment(equipmentId: number): { isSuccess: boolean } {
          console.log("Equipment ID changed:", equipmentId);
        if (!equipmentId) {
           return { isSuccess: false };
        }

        const equipmentInfoById = equipmentInfo(entities, equipmentId);

        if(equipmentInfoById.skid == null){
            dispatch(setEquipment(equipmentInfoById.equipment));
            setEquipmentId(equipmentId);
            setEquipmentWithoutSkid(true);
            return { isSuccess: true };
        } else if(equipmentInfoById.skid != null) {
            dispatch(setSkid(equipmentInfoById.skid));
            dispatch(setEquipment(equipmentInfoById.equipment));
            setEquipmentId(equipmentId);
            setEquipmentWithoutSkid(false);
            return { isSuccess: true };
        }
        return { isSuccess: false };
    }

    return navigateToEquipment;
}

const equipmentInfo = (entities: DashboardNavigationMenu[], equipmentId: number) => {
    for (const powerStation of entities) {
        for (const skid of powerStation.skidList) {
            for (const equipment of skid.equipmentList) {
                if(equipmentId === equipment.id) {
                    return { skid, equipment };
                }
            }
        }
        for (const equipment of powerStation.equipmentList) {
                if(equipmentId === equipment.id) {
                    return { skid: null, equipment };
                }
        }
    }

    return { skid: null, equipment: null };
}